<app-main-header [name_main]="'Administrar modelos de datos'">
  <button class="check-btn" mat-flat-button color="primary" (click)="createSchema()">
    CREAR
  </button>
  <button [disabled]="!selectedItems.length" class="check-btn delete-btn" mat-flat-button color="warn"
    (click)="deleteSelectedSchemas()">
    BORRAR
  </button>
</app-main-header>

@if (isLoading) {
  <section class="schemas-admin-page">
    <div class="status-box">Cargando modelos de datos...</div>
  </section>
} @else {
  <app-data-table
    [data]="schemas"
    [columns]="columns"
    [rows]="50"
    [rowsPerPageOptions]="[10, 25, 50]"
    [selection]="selectedItems"
    [sortField]="'name'"
    [sortOrder]="1"
    [showFilters]="true"
    (selectionChange)="onSelectionChange($event)"
    (editItem)="onEditSchema($event)"
    (deleteItems)="onDeleteFromTable($event)">
  </app-data-table>
}
